import { Navbar, Container } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Emitter from '../../utils/emitter';
import Logo from "./logo"
import Menu from "./menu"
import navMobileText from "../../assets/images/ARTPARK-text.png"
import { useNavigate } from 'react-router';
import CallParticipation from '../../pages/academic/robotChallange/CallParticipation/CallParticipation';



function Header({ blackToggle }) {

  const navigate = useNavigate();
  const [toggle, setToggle] = useState(1);
  useEffect(() => {
    Emitter.on('TOGGLE_MENU', (newValue) => setToggle(!toggle));
  });

  function menuToggle(condition) {
    setToggle(!toggle)

    Emitter.emit('TOGGLE_MENU', 'TOGGLE');

  }
  function brandToggle(condition) {

    setToggle(1)
    if (!toggle) {
      Emitter.emit('TOGGLE_MENU', 'TOGGLE');
    }

  }

  return (

    <nav className="navbar navbar-expand-lg navbar-light bg-light">
   
      <Navbar fixed="top nav-top" >
      <Container  >
        <Navbar.Brand href="/#home" onClick={() => brandToggle(1)}><Logo /></Navbar.Brand>

        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end">
          <Menu blackToggle={blackToggle}/>
          {toggle ? null : <div className={'closeBox text-blue'} onClick={() => menuToggle()}>
            <span className="navCloseBox">
              <FontAwesomeIcon icon={faTimes} />
            </span>
            <span className="d-none d-md-block"> CLOSE</span>
          </div>}
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </nav>

    
  );
}

export default Header;